export default {
  add_rate: 'Añadir tarifa',
  remove_rate: 'Eliminar tarifa',
  gateways: {
    adyen: 'Adyen',
  },
  methods: {
    fallback: 'Cualquier método de pago',
    card: 'Tarjeta',
    apple_pay: 'Apple Pay',
    google_pay: 'Google Pay',
    link: 'Link',
    paypal: 'PayPal',
    pay_by_bank: 'Pay by Bank',
    sepa_debit: 'Adeudo directo SEPA',
    sofort: 'Sofort',
    giropay: 'giropay',
    bacs_debit: 'Adeudo directo Bacs',
    stripe_other: 'Otros métodos de Stripe',
  },
  fields: {
    percentage: 'Porcentaje',
    fixed: 'Importe fijo',
    min: 'Importe mínimo',
  },
  // Spelled out from the row's own values, so a rate reads as the fee it
  // produces. {{method}} is the payment method, {{fixed}}/{{floor}} are
  // formatted amounts, {{percentage}} is a plain number.
  explanation: {
    none: 'Aún no se cobra nada en {{method}}: estos pagos obtienen un margen del 0 % hasta que se establezca una tarifa.',
    floor_only:
      'En {{method}}, la comisión de procesamiento es de {{floor}} por cada pago, sea cual sea el total del pedido.',
    percentage: 'En {{method}}, la comisión de procesamiento es del {{percentage}} % del total del pedido.',
    percentage_floor:
      'En {{method}}, la comisión de procesamiento es del {{percentage}} % del total del pedido y como mínimo {{floor}}.',
    fixed: 'En {{method}}, la comisión de procesamiento es de {{fixed}} por pago.',
    fixed_floor: 'En {{method}}, la comisión de procesamiento es de {{fixed}} por pago y como mínimo {{floor}}.',
    combined:
      'En {{method}}, la comisión de procesamiento es de {{fixed}} fijos más el {{percentage}} % del total del pedido.',
    combined_floor:
      'En {{method}}, la comisión de procesamiento es de {{fixed}} fijos más el {{percentage}} % del total del pedido y como mínimo {{floor}}.',
    redundant_floor:
      'El mínimo de {{floor}} nunca se aplica: el importe fijo ya lo alcanza en cada pago. Establécelo por encima de {{fixed}} o bórralo.',
  },
  example: 'Ejemplo: en un pedido de {{total}}, la comisión de procesamiento es de {{fee}}.',
};
